import { asyncActionCreator } from '../../../../../../../utils/generalUtilities';

export const GET_BPT_PREFERENCE_ANALYSIS_IMAGE_ASYNC = asyncActionCreator(
    '/pages/brandPreferenceTracker/GET_BPT_PREFERENCE_ANALYSIS_IMAGE_ASYNC'
);
export const GET_BPT_PREFERENCE_ANALYSIS_IMAGE_DATA =
    '/pages/brandPreferenceTracker/GET_BPT_PREFERENCE_ANALYSIS_IMAGE_DATA';

export const getBptPreferenceAnalysisImageActionCreator = payload => ({
    type: GET_BPT_PREFERENCE_ANALYSIS_IMAGE_DATA,
    payload,
});
